import { useState, useEffect } from "react"
import { useNavigate } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"
import SelectField from "../../Shared/SelectField"

const MenuForm = (props) => {
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [roleOption, setRoleOption] = useState([
        {id: "Admin", name: "Admin", key: 1},
        {id: "Administration", name: "Administration", key: 2},
        {id: "Administrator", name: "Administrator", key: 3}]);

    const [formData, setFormData] = useState({
        name: "",
        display_name: "",
        group: "",
        title: "",
        role: "",
        path: ""
    })
    const {name, display_name, group, title, role, path} = formData

    const navigate = useNavigate()

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const payload = {name, display_name, group, title, role, path}
        addMenu(payload)
    }
    
    // add role
    const addMenu = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/menus/', payload)
            setIsLoading(false)
            toast.success(response?.data?.detail)
            navigate('/menus')
            
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422){
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response.data?.detail)
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Create New Menu</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <InputField
                                placeholder="Menu Name"
                                name="name"
                                type="text"
                                label="Name"
                                value={name}
                                onChange={onChange}
                                error={errors.name}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                placeholder="Display Name"
                                name="display_name"
                                type="text"
                                label="Display Name"
                                value={display_name}
                                onChange={onChange}
                                error={errors.display_name}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                placeholder="Menu Group"
                                name="group"
                                type="text"
                                label="Group"
                                value={group}
                                onChange={onChange}
                                error={errors.group}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <InputField
                                name="title"
                                type="text"
                                label="Title"
                                value={title}
                                onChange={onChange}
                                error={errors.title}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                name="path"
                                type="text"
                                label="Path"
                                value={path}
                                onChange={onChange}
                                error={errors.path}
                            />
                        </div>
                        <div className="col-md-4">
                            <SelectField
                                name="role"
                                label="Role"
                                value={role}
                                options={roleOption}
                                onChange={onChange}
                                error={errors.role}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Save Menu" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default MenuForm
